import { CustomSelectAndChildren } from './../../../../../components/CustomSelectAndChildren';
import { MenuItem, Typography } from '@mui/material';
import { CustomDatePicker } from './../../../../../components/CustomDatePicker';
import NotInformation from '../../../../../components/NotInformation';
import CustomFullRowCard from './../../../../../components/CustomFullRowCard';
import { ArrowRightIcon, InfoChip } from '../../../../../components/buttons/IconButtons';
import routes from '../../../../../Routes/routes';
import ButtonActionsCard from '../../../../../components/buttons/ButtonActionsCard';
import CustomChip from './../../../../../components/CustomChip';
import CustomUserChip from './../../../../../components/CustomUserChip';
import AvailabilityChip from './AvailabilityChip';
import { CalendarApp } from './../Functionality/CalendarApp';
import { colors } from '../../../../../enums/colors';
import { militaryHourToTimeString } from '../../../../../utils/TimeConversion';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const Calendar = ({ t, DEV, permission, navigate, isFutureDate }) => {
    const {
        handleChange,
        emptyFields,
        monthName,
        date,
        diner,
        allCafeterias,
        menuByCafeteriaIdServingDate,
        canUpdateMenu,
    } = CalendarApp({isFutureDate, DEV, permission});

    return (
        <div className='calendar-container'>
            <div className='d-flex mb-3 mt-3 px-0 gap-3'>
                <div className='w-50'>
                    <CustomSelectAndChildren
                        id='slt_c_diner'
                        name='diner'
                        trans='diner'
                        value={diner}
                        onChange={handleChange}
                        emptyFields={emptyFields}
                        showNoSelectionOption={false}
                        required={true}
                    >
                        {allCafeterias?.map((meal) => (
                            <MenuItem key={meal.id} value={meal.id}>
                                {t(meal.name)}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
                <div className='w-50'>
                    <CustomDatePicker
                        id='dp_c_date'
                        name='date'
                        trans='cafeteria_serving_date'
                        value={date}
                        openTo='day'
                        required={true}
                        onChange={handleChange}
                        emptyFields={emptyFields}
                    />
                </div>
            </div>
            {menuByCafeteriaIdServingDate?.content &&
            Array.isArray(menuByCafeteriaIdServingDate.content) &&
            menuByCafeteriaIdServingDate.content.length > 0 ? (
                <>
                    <div className='d-flex justify-content-center mb-2'>
                        <span className='font-color-secondary-600 ibl-h3 ibl-font-w-600'>{t(monthName)}</span>
                    </div>
                    {menuByCafeteriaIdServingDate.content.map((item, index) => (
                        <div key={item.id} className='mb-3'>
                            <CustomFullRowCard
                                actionLeft={militaryHourToTimeString(item.releaseHour)}
                                actionRight={
                                    <div className='right-items mb-1'>
                                        {Array.isArray(item.foodieMealTimeStocks) &&
                                            item.foodieMealTimeStocks.length > 0 && (
                                                <div className='d-flex flex-wrap gap-2'>
                                                    {item.foodieMealTimeStocks.map((mt, i) => (
                                                        <CustomChip
                                                            key={i}
                                                            legend={mt.mealTimeName}
                                                            fontColor={colors.secondary700}
                                                            borderColor={colors.secondary150}
                                                            background={colors.secondary100}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        <AvailabilityChip value={item.totalStock} />
                                    </div>
                                }
                                btnActions={(() => {
                                    const allowUpdate = canUpdateMenu(item);
                                    return (
                                        <ButtonActionsCard
                                            id={`btn_ic_actions_card_${index}`}
                                            name={allowUpdate ? 'update' : 'details'}
                                            Icon={ArrowRightIcon}
                                            onClick={() => {
                                                const path = allowUpdate
                                                    ? `${routes.foodieMenu.update}${item.id}`
                                                    : `${routes.foodieMenu.details}${item.id}`;
                                                navigate(path);
                                            }}
                                        />
                                    );
                                })()}
                            >
                                <div className='d-flex w-100 flex-row'>
                                    <div className='w-10'>
                                        <Typography className='ibl-font-w-600 ibl-description'>
                                            {item.foodieItemName}
                                        </Typography>
                                        <Typography className='ibl-font-w-500 ibl-ientry-p'>{t('stock')}</Typography>
                                        <Typography className='ibl-font-w-500 ibl-ientry-p'>
                                            {item.totalStock}
                                        </Typography>
                                    </div>

                                    <div className='w-90'>
                                        <div className='d-flex flex-wrap gap-2 mb-2'>
                                            <CustomUserChip
                                                className='mt-0 chip-secondary-100'
                                                key={1}
                                                name={t('department')}
                                                Icon={InfoChip}
                                                showAvatar={true}
                                                classNameIcon={'icon-color-secondary-700'}
                                            />
                                        </div>

                                        <div className='d-flex flex-wrap'>
                                            {Array.isArray(item.departments) &&
                                                item.departments.map((element) => (
                                                    <CustomUserChip
                                                        key={element.departmentId}
                                                        name={element.departmentName}
                                                    />
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            </CustomFullRowCard>
                        </div>
                    ))}
                </>
            ) : (
                <NotInformation card={true} text={t('no_meals_for_today')} />
            )}
        </div>
    );
};

export default Calendar;
